export default ["600px", "960px", "1024px", "1280px", "1920px"];